// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Paper, PaperProps, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface Props extends Pick<PaperProps, 'sx'> {
  /**
   * The title displayed at the top of the card.
   */
  title: string;

  /**
   * The content to display inside the card.
   */
  children: ReactNode;
}

/**
 * Renders a card container for grouping project detail fields.
 * Provides consistent styling with a title header and content area.
 */
export function ProjectDetailCard(props: Props) {
  return (
    <Paper
      variant="outlined"
      sx={{
        padding: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...props.sx,
      }}
    >
      <Stack spacing={2} sx={{ height: '100%' }}>
        <Typography variant="subtitle1">{props.title}</Typography>
        {props.children}
      </Stack>
    </Paper>
  );
}
